import {AxiosResponse} from 'axios';
import {enqueueSnackbar} from 'notistack';

import {
  API_BASE_URL,
  UPLOAD_FILEUPLOAD_FINISHED,
  UPLOAD_PARTIAL_SUCCESS,
  MESSAGE_DURATION_LONG,
  UPLOAD_BAD_FILES,
  UPLOAD_SUCCESS,
  UPLOAD_ABORTED,
  INVALID_GTIN_OR_PIM_NUMBER,
  UPLOAD_ERROR,
} from '../../constants';
import {
  DownloadOrderResponseDto,
  UploadedFileDto,
  UploadErrorDto,
  UploadResponseDto,
} from '../../models';
import {post} from '../api';

export function uploadFiles(
  formData: FormData,
  token: string,
  abortController: AbortController,
  setUploadProgress: (progress: number) => void,
  setUploading: (value: boolean) => void,
  resetDialog: () => void,
  setUploadedFiles: (files: UploadedFileDto[]) => void,
  setErrorFiles: (files: UploadErrorDto[]) => void,
) {
  post(`${API_BASE_URL}/uploadFile`, {
    data: formData,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
    responseType: 'json',
    signal: abortController.signal,
    onUploadProgress: (progressevent: {progress?: number}) => {
      const progress = progressevent.progress ?? 0;
      setUploadProgress(progress * 100);
      if (progress === 1) {
        enqueueSnackbar(UPLOAD_FILEUPLOAD_FINISHED, {
          variant: 'info',
        });
      }
    },
  })
    .then((response: AxiosResponse<UploadResponseDto>) => {
      setUploading(false);
      if (response.status === 207) {
        if (response.data.uploadedFiles.length > 0) {
          enqueueSnackbar(UPLOAD_PARTIAL_SUCCESS, {
            variant: 'warning',
            autoHideDuration: MESSAGE_DURATION_LONG,
          });
        } else {
          enqueueSnackbar(UPLOAD_BAD_FILES, {
            variant: 'error',
            autoHideDuration: MESSAGE_DURATION_LONG,
          });
        }
      }

      if (response.status === 200) {
        enqueueSnackbar(UPLOAD_SUCCESS, {
          variant: 'success',
          autoHideDuration: MESSAGE_DURATION_LONG,
        });
        resetDialog();
      }

      setUploadedFiles(response.data.uploadedFiles);
      setErrorFiles(response.data.errors);
    })
    .catch(error => {
      if (error.code === 'ERR_CANCELED') {
        enqueueSnackbar(UPLOAD_ABORTED, {
          variant: 'info',
        });
      } else {
        switch (error.response.status) {
          case 422:
            enqueueSnackbar(INVALID_GTIN_OR_PIM_NUMBER, {variant: 'error'});
            break;
          case 413:
            enqueueSnackbar(error.response.data, {variant: 'warning'});
            break;
          default:
            enqueueSnackbar(UPLOAD_ERROR, {
              variant: 'error',
            });
        }
      }
      setUploading(false);
    });
}

export function downloadOrder(
  singleFile: boolean,
  derivateString: string,
  urlList: Record<string, string>[],
  token: string | undefined,
): Promise<AxiosResponse<DownloadOrderResponseDto>> {
  return post(
    `${API_BASE_URL}/downloadOrder?singleFile=${singleFile}${derivateString}`,
    {
      data: JSON.stringify(urlList),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      responseType: 'json',
    },
  );
}
